import { SuiteManifest } from '../manifest';
import { feesRoutes } from './routes';

export const feesManifest: SuiteManifest = {
  id: 'fees',
  code: 'S4_FEES',
  name: 'Accounting & Fees',
  basePath: '/fees',
  icon: 'credit-card',
  description: 'Fee structures, online course checkouts, gapless legal invoices, double-entry ledger balance, and Razorpay/Stripe HMAC verification.',
  requiredPermission: 'fees.read',
  allowedRoles: ['owner', 'admin', 'branch_head', 'counselor', 'accountant', 'student', 'parent'],
  nav: [
    { label: 'Invoices & Receipts', path: '/fees/invoices', icon: 'file-text', group: 'Billing', status: 'live' },
    { label: 'Course Purchases & Orders', path: '/fees/purchases', icon: 'shopping-cart', group: 'Billing', status: 'live' },
    { label: 'Fee Structures', path: '/fees/plans', icon: 'credit-card', group: 'Billing', status: 'live', permission: 'fees.manage', allowedRoles: ['owner', 'admin', 'branch_head', 'counselor', 'accountant'] },
    { label: 'Double-Entry Ledger', path: '/fees/ledger', icon: 'receipt', group: 'Accounting', status: 'live', permission: 'fees.accounting.read', allowedRoles: ['owner', 'admin', 'accountant'] },
    { label: 'Gateways & Payments', path: '/fees/payments', icon: 'dollar-sign', group: 'Accounting', status: 'live', permission: 'fees.accounting.read', allowedRoles: ['owner', 'admin', 'accountant'] },
  ],
  routes: feesRoutes,
};

export { feesRoutes } from './routes';
export default feesManifest;
